module.exports = __webpack_public_path__ + "static/media/Silver_Medal_Icon.887f9478.svg";